import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import hoastLogo from "../../../assets/images/HOAST-LOGO_2 1.png";
import EllipsisLoader from '../../../base_component/EllipsisLoader/EllipsisLoader';
import { useState } from 'react';
import { resendOTP } from '../../../service/ApiServices';
import toast from 'react-hot-toast';

export default function ForgotPassword() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const initialValues = {
        email: '',
    };

    const validationSchema = Yup.object({
        email: Yup.string().email("Invalid email").required("Email is required"),
    });

    const onSubmit = async (values) => {
        setIsLoading(true);
        
        const params = {
            email: values.email,
        };

        resendOTP(params)
            .then((res) => {
                const message = res?.data?.message;
                const status = res?.data?.status;
                
                if (status === 1) {
                    setIsLoading(false);
                    toast.success(message);
                    
                    const expiryTime = Date.now() + (60 * 1000);
                    localStorage.setItem('otpExpiryTime', expiryTime.toString());
                    
                    navigate("/verification/forgot", {
                        state: {
                            email: values.email,
                        },
                    });
                } else {
                    setIsLoading(false);
                    toast.error(message);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                const message = err?.response?.data?.message || 'Failed to send OTP';
                toast.error(message);
            });
    };

    return (
        <div className="h-screen flex flex-col items-center justify-center px-4 ">
            <div className="flex justify-center mb-4">
                <img src={hoastLogo} alt="Logo" className="md:h-36 h-24" />
            </div>

            <div className="bg-white md:p-8 p-5 rounded-xl shadow-md w-full max-w-xl">
                <h2 className="md:text-2xl text-xl font-semibold text-start mb-1">Forgot your password?</h2>
                <p className="text-start text-sm text-gray-500 mb-6">
                    Reset your password and get back to your account.
                </p>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, isValid }) => (
                        <Form className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-[#667085]">
                                    Email
                                </label>
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder="Enter"
                                    className="mt-1 block w-full px-4 py-3 border-2 border-gray-300 rounded-xl shadow-sm focus:outline-none focus:border-[#24B565]"
                                />
                                <ErrorMessage name="email" component="div" className="text-red-500 text-xs mt-1" />
                            </div>

                            <button
                                type="submit"
                                disabled={!values.email || isLoading}
                                className={`w-full h-[52px] rounded-xl cursor-pointer transition duration-200 outline-none flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed ${values.email
                                    ? 'bg-black text-white'
                                    : 'bg-[#F0F1F3] text-gray-500'
                                    }`}
                            >
                                {isLoading ? (
                                    <EllipsisLoader color={values.email ? "white" : "red"} />
                                ) : (
                                    'Continue'
                                )}
                            </button>

                            <div
                                onClick={() => navigate(-1)}
                                className="flex items-center justify-center mt-6 text-sm text-gray-700 cursor-pointer"
                            >
                                <FiArrowLeft className="mr-2" />
                                Go back
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}
